import api from './api';

const sponsorService = {
  getSponsors: async () => {
    try {
      const response = await api.get('/api/sponsor/select/');
      const data = response.data;
      
      // Handle auto-bypass response for single-sponsor users
      if (data.auto_selected) {
        console.log('[SPONSOR SERVICE] Auto-bypass detected, updating localStorage');
        
        // Update tokens if provided
        if (data.tokens?.access_token) {
          localStorage.setItem('authToken', data.tokens.access_token);
          api.defaults.headers.common['Authorization'] = `Bearer ${data.tokens.access_token}`;
          
          if (data.tokens.refresh_token) {
            localStorage.setItem('refreshToken', data.tokens.refresh_token);
          }
        }
        
        // Store selected sponsor info
        if (data.sponsor_id && data.sponsor_name) {
          localStorage.setItem('selectedSponsor', JSON.stringify({
            id: data.sponsor_id,
            name: data.sponsor_name
          }));
          console.log('[SPONSOR SERVICE] Sponsor auto-selected:', data.sponsor_id);
        }
      }
      
      return data;
    } catch (error) {
      console.error('Error fetching sponsors:', error);
      throw error;
    }
  },

  // Admin / superuser: get all sponsors in the system via SponsorViewSet
  getAllSponsors: async () => {
    try {
      const response = await api.get('/api/sponsors/');
      // DRF pagination may wrap results in .results
      return response.data?.results || response.data;
    } catch (error) {
      console.error('Error fetching all sponsors:', error);
      throw error;
    }
  },

  getMySponsorLinks: async () => {
    try {
      const response = await api.get('/api/users/me/sponsors/');
      return response.data;
    } catch (error) {
      console.error('Error fetching user sponsor links:', error);
      throw error;
    }
  },

  addSponsorToUser: async (sponsorId) => {
    try {
      const response = await api.post('/api/users/me/sponsors/', { sponsor_id: sponsorId });
      return response.data;
    } catch (error) {
      console.error('Error adding sponsor to user:', error);
      throw error;
    }
  },

  removeSponsorFromUser: async (sponsorId) => {
    try {
      const response = await api.delete('/api/users/me/sponsors/', { data: { sponsor_id: sponsorId } });
      return response.data;
    } catch (error) {
      console.error('Error removing sponsor from user:', error);
      throw error;
    }
  },

  createSponsor: async (sponsorData) => {
    try {
      const response = await api.post('/api/sponsors/', sponsorData);
      return response.data;
    } catch (error) {
      console.error('Error creating sponsor:', error);
      throw error;
    }
  },

  getSponsor: async (sponsorId) => {
    try {
      const response = await api.get(`/api/sponsors/${sponsorId}/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching sponsor:', error);
      throw error;
    }
  },

  updateSponsor: async (sponsorId, sponsorData) => {
    try {
      const response = await api.patch(`/api/sponsors/${sponsorId}/`, sponsorData);
      return response.data;
    } catch (error) {
      console.error('Error updating sponsor:', error);
      throw error;
    }
  },

  // Dedicated audited endpoint for the approval-enforcement override (FECOA-1646)
  setSponsorApprovalEnforcement: async (sponsorId, value) => {
    try {
      const response = await api.patch(`/api/sponsors/${sponsorId}/enforce-approval/`, {
        enforce_approval: value,
      });
      return response.data;
    } catch (error) {
      console.error('Error updating sponsor approval enforcement:', error);
      throw error;
    }
  },

  async selectSponsor(sponsorId) {
    try {
      const { data } = await api.post('/api/sponsor/select/', { sponsor_id: sponsorId });

      // Set the new tokens
      if (data.tokens?.access_token) {
        localStorage.setItem('authToken', data.tokens.access_token);
        // Update the Authorization header in axios instance
        api.defaults.headers.common['Authorization'] = `Bearer ${data.tokens.access_token}`;
      }

      if (data.tokens?.refresh_token) {
        localStorage.setItem('refreshToken', data.tokens.refresh_token);
      }

      // Store selected sponsor details
      if (data.sponsor_id && data.sponsor_name) {
        localStorage.setItem('selectedSponsor', JSON.stringify({
          id: data.sponsor_id,
          name: data.sponsor_name
        }));
      }

      return data;
    } catch (error) {
      console.error('Error selecting sponsor:', error);
      if (error.response) {
        console.error('Response data:', error.response.data);
        console.error('Response status:', error.response.status);
      }
      throw error;
    }
  },
};

export default sponsorService;